export type ProtectedSelfTransfer = 'PROTECTED_SELF_TRANSFER';
export type NonProtectedSelfTransfer = 'NON_PROTECTED_SELF_TRANSFER';
export type SelfTransferMessage = 'SELF_TRANSFER';
export type SelfTransfer = ProtectedSelfTransfer | NonProtectedSelfTransfer;

export const SELF_TRANSFER: SelfTransferMessage = 'SELF_TRANSFER';
export const PROTECTED_SELF_TRANSFER: ProtectedSelfTransfer = 'PROTECTED_SELF_TRANSFER';
export const NON_PROTECTED_SELF_TRANSFER: NonProtectedSelfTransfer = 'NON_PROTECTED_SELF_TRANSFER';

export const SELF_TRANSFER_BANNER_VARIANTS = {
  ALL_OPTIONS: 'ALL_OPTIONS',
  SOME_OPTIONS: 'SOME_OPTIONS',
  AIRPORT_CHANGE: 'AIRPORT_CHANGE',
} as const;

export type SelfTransferBannerVariant =
  (typeof SELF_TRANSFER_BANNER_VARIANTS)[keyof typeof SELF_TRANSFER_BANNER_VARIANTS];
